const InstrumentJigAdd = () => import("@/pages/lab/instrumentjig/InstrumentJigAdd");
const InstrumentJigEdit = () => import("@/pages/lab/instrumentjig/InstrumentJigEdit");
const InstrumentIndex = () => import("@/pages/lab/instrument/InstrumentIndex");
const InstrumentDetail = () =>
  import("@/pages/lab/instrument/InstrumentDetail");
const InstrumentAdd = () => import("@/pages/lab/instrument/InstrumentAdd");
const InstrumentEdit = () => import("@/pages/lab/instrument/InstrumentEdit");
const InstrumentSingle = () => import("@/pages/lab/instrument/InstrumentSingle");
const InstrumentAuditTrail = () => import("@/pages/lab/instrument/InstrumentAuditTrail");
const InstrumentAuditTrailHistory = () => import("@/pages/lab/instrument/InstrumentAuditTrailHistory");

export class InstrumentRoutes {
  constructor() {
    this.route_root = "instrument";
    this.type_single = "Instrument";
    this.type_plural = "Instruments";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c('router-view')
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: InstrumentIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: InstrumentAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":instrument_id",
            component: InstrumentSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: InstrumentDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: InstrumentEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "instrument-jig/add",
                name: "Add Jig",
                component: InstrumentJigAdd,
                meta: { requiresAuth: true }
              },
              {
                path: "instrument-jig/:jig_id/edit",
                name: "Edit Jig",
                component: InstrumentJigEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: InstrumentAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: InstrumentAuditTrailHistory,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ]

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
